__turbopack_context__.v({
  "root": "Wrapper-module-scss-module__zATqSG__root",
});
